import { render, staticRenderFns } from "./joinUsDetail.vue?vue&type=template&id=6567646c&scoped=true"
import script from "./joinUsDetail.vue?vue&type=script&lang=js"
export * from "./joinUsDetail.vue?vue&type=script&lang=js"
import style0 from "./joinUsDetail.vue?vue&type=style&index=0&id=6567646c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567646c",
  null
  
)

export default component.exports